/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { ModalMessageProps } from 'types/components/Modal';

export default function ModalMessage({ message }: ModalMessageProps): JSX.Element | null {
  if (!message) {
    return null;
  }
  return (
    <div className="message-container">
      <div className="message">
        <p id="Modal_message">{message}</p>
      </div>
    </div>
  );
}
